import * as actions from '../actions/generalCountryActionTypes';


const initialState = {
  countryList: {
    success: true,
    errors: null,
    warnings: null,
    countries: [   
      {
        countryKey: "IT",
        propName: "Italy",
        translations: [
          {
            language: "deu",
            propName: "Italien"
          },
          {
            language: "ita",
            propName: "Italia"
          },
          {
            language: "eng",
            propName: "Italy"
          }
        ] 
      }
    ]
  }
}


function generalCountry(state = initialState, action) {  
  switch (action.type) {
    case actions.GENERAL_COUNTRYLIST_SET:
      return {
        ...state, 
        countryList: action.countryList
      }    
    default:        
      return state
  } 
}


export default generalCountry
